import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningStatusEnum from '../../../Enums/PlanningStatusEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';

export default class SLSearchParams extends SearchParamsBase {
  initialize() {
    this.ServiceId = '';
    this.ClientId = '';
    this.ClientName = '';
    this.OpportunityName = '';
    this.ServiceName = '';
    this.OfficeIds = [];
    this.Owner = '';
    this.Status = [PlanningStatusEnum.Created, PlanningStatusEnum.ClientConfirmed];
    this.EndDateTill = dateTimeHelper.indefiniteDateValue();
  }

  static defaultOfficeId = '';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };
    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'ServiceId', label: 'ServiceId', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'ClientId', label: 'ClientId', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'ClientName', label: 'Client Name', className: 'col-3', type: InputTypesEnum.Text },
    {
      fieldName: 'OpportunityNameOrId',
      label: 'Opportunity Name or Id',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'OfficeIds', label: 'Office', className: 'col-6', type: InputTypesEnum.OfficeOrGroupMultiSelect },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-6',
      type: InputTypesEnum.MultiChoice,
      options: SLSearchParams.getStatusOptionsFunction(),
    },
    { fieldName: 'ServiceName', label: 'Service Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Owner', label: 'Owner', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'EndDateTill', label: 'End Date Till', className: 'col-4', type: InputTypesEnum.DateWithIndefinite },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'SLSearchParams';

  static getStatusOptionsFunction() {
    return selectHelper.generateSelectValues(['Created', 'ClientConfirmed', 'Closed', 'OnHold', 'Cancelled']);
  }
}
